import React from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '../../data/mock';
import { ArrowLeftRight, Filter, Handshake } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0f1f2e] text-white">
      {/* Trust Banner */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16">
            <div className="flex items-center space-x-3 text-slate-300">
              <Filter className="w-5 h-5 text-emerald-400" />
              <span className="text-sm font-medium">Selective Evaluation</span>
            </div>
            <div className="flex items-center space-x-3 text-slate-300">
              <ArrowLeftRight className="w-5 h-5 text-emerald-400" />
              <span className="text-sm font-medium">Risk-Shifting Model</span>
            </div>
            <div className="flex items-center space-x-3 text-slate-300">
              <Handshake className="w-5 h-5 text-emerald-400" />
              <span className="text-sm font-medium">Outcome-Aligned</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">IP</span>
              </div>
              <span className="text-xl font-semibold text-white tracking-tight">IpFunders</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              IP risk-shifting infrastructure. We evaluate, fund, and develop IP assets — so innovators can pursue protection without bearing the full burden.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">Company</h4>
            <ul className="space-y-4">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For You Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">For You</h4>
            <ul className="space-y-4">
              {footerLinks.forYou.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">Legal</h4>
            <ul className="space-y-4">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} IpFunders. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Shifting the risk of creating intellectual property.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
